module.exports = __webpack_public_path__ + "img/album15_23.05885753.jpg";